export default "__VITE_ASSET__Dp53t2Jv__"